<div mat-dialog-content>
  <h1 mat-dialog-title>Upload your data</h1>
  <button class="close-button" mat-icon-button aria-label="close dialog" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
  <div>
    <ul>
      <li>Click on the button below</li>
    </ul>
    <div class="input-container">
      <input type="file" class="inputfile" webkitdirectory=true (change)="readFiles($event)" #fileUpload>
      <button mat-raised-button color="primary" (click)="fileUpload.click()">
        <mat-icon>upload</mat-icon>
        Use your own file
      </button>
    </div>
    <ul>
      <li>Navigate to your unzipped Facebook archive</li>
      <li>Select the "message" Folder and confirm</li>
    </ul>
  </div>

  <h1 mat-dialog-title>We are not the NSA, Facebook, or Cambridge Analytica</h1>
  <div>
    <p>
      You may get a warning saying that your data will be downloaded. While this can be frightening, this is actually false.
      The data will loaded <i>into your browser</i>, not on internet. Computations will be done locally
      without a single piece of data leaving your computer.
    </p>
    <p>
      The truth is we don't have any interest in your data, we don't even have servers to store it. We are just
      two students who want to empower you to do something cool with your data.
    </p>
    <p>
      All of the code behind this application is available <a href="https://github.com/adurivault/FBMessage">here</a>.
      It means that anyone familiar with programming can check that this application does what we say it does, and only what
      we say it does.
    </p>
    <p>
      If you are not familiar with programming, and you still do not trust us (Who can blame you? This is written
      by two strangers on internet after all...) you can cut your internet connexion before selecting the files. Once the
      page is loaded, everything will work fine without internet. This way you can be absolutely sure that the data is not sent to
      anybody.
    </p>

    <p>
      Original Authors :
      <a href="https://github.com/MathReynaud"> Mathilde Reynaud </a> |
      <a href="https://github.com/adurivault"> Augustin Durivault </a> <br>
    </p>

    <p>
      Refactor by :
      <a href="https://github.com/pjpscriv"> Peter Scriven </a>
    </p>
  </div>
</div>
